import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferInventories {
  constructor($scope, OfferService, UserService, UserProductService) {
    $scope.tabs = [
      {
        title: 'Search Results',
        offers: [],
        items: [],
        has_reels: false,
        has_sheets: false,
        reels_checked: false,
        sheets_checked: false,
        filter: {
          offer_id: null
        },
      },
      {
        title: 'Selected Items',
        offers: [],
        items: [],
        has_reels: false,
        has_sheets: false,
        reels_checked: false,
        sheets_checked: false
      }
    ];

    $scope.filter_items_by_offer = function(tab_index) {
      var offer_id = $scope.tabs[tab_index].filter.offer_id;
      angular.forEach($scope.tabs[tab_index].items, function(item) {
        if (offer_id)
          item.visible = item.offer_id == offer_id;
        else
          item.visible = true;
      });
    };

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.get_shipment_cities = function() {
      $scope.filter.shipment_city_id = null;
      $scope.shipment_cities = [];
      OfferService.get_supplier_shipment_cities($scope.filter.supplier_id).then(function(data) {
        if (data.success && data.cities.length > 0) {
          $scope.shipment_cities = data.cities;
          $scope.filter.shipment_city_id = data.cities[0].id;
        }
      });
    };

    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.supplier_id = ui.item.id;
          $scope.supplier_company = ui.item.value;
          $(this).val('');
          $scope.$apply();
          $scope.get_shipment_cities();
          return false;
        }
      });
    };

    $scope.set_buyer_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.buyer_id = ui.item.id;
          $scope.buyer_company = ui.item.value;
          $(this).val('');
          $scope.$apply();
          $scope.load_buyer_user_products(ui.item.id);
          return false;
        }
      });
    };

    $scope.load_buyer_user_products = function(buyer_id) {
      UserProductService.get_user_products(buyer_id).then(function(data) {
        _.each(data.user_products, function(user_product) {
          if (user_product.product) {
            $scope.buyer_user_products.push({
              id: user_product.id,
              title: user_product.product.title,
              checked: false
            });
          }
        });
      });
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.set_filter = function() {
      $scope.filter = {
        supplier_id: null,
        buyer_id: null,
        title: null,
        date_from: null,
        date_to: null,
        shipment_city_id: null,
        offer_id: window.offer ? window.offer.id : null,
        personal_search_mode: null,
        specs: []
      };
    };

    $scope.remove_supplier = function() {
      $scope.filter.supplier_id = null;
      $scope.supplier_company = null;
      $('input.supplier_company').val('');
    };

    $scope.remove_buyer = function() {
      $scope.filter.buyer_id = null;
      $scope.buyer_company = null;
      $('input.buyer_company').val('');
      $scope.buyer_user_products = [];
    };

    $scope.search = function() {
      if (!$scope.filter.supplier_id && !window.offer) {
        alert('Please select a supplier first!');
        return false;
      }
      $scope.searching = true;
      $scope.tabs[0].offers = [];
      $scope.tabs[0].items = [];
      $scope.tabs[0].filter.offer_id = null;
      OfferService.search_for_inventories($scope.filter).then(function(data) {
        if (data.success) {
          $scope.tabs[0].offers = data.offers;
          $scope.tabs[0].items = data.items;
          $scope.set_tab_properties(0);
          $scope.searching = false;
        }
      });
    };

    $scope.check_items = function(tab_index, is_reels) {
      angular.forEach($scope.tabs[tab_index].items, function(item) {
        if (is_reels && item.is_reels && item.visible)
          item.checked = $scope.tabs[tab_index].reels_checked;
        else if (!is_reels && !item.is_reels && item.visible)
          item.checked = $scope.tabs[tab_index].sheets_checked;
      });
    };

    $scope.select_items = function() {
      angular.forEach($scope.tabs[0].items, function(item) {
        if (item.checked) {
          var item_copy = _.findWhere($scope.tabs[1].items, {
            id: item.id
          });
          if (typeof item_copy == 'undefined')
            $scope.tabs[1].items.push(angular.copy(item));
        }
      });
      $scope.set_tab_properties(1);
    };

    $scope.remove_items = function() {
      var temp_items = [];
      angular.forEach($scope.tabs[1].items, function(item) {
        if (item.checked)
          temp_items.push(item);
      });
      angular.forEach(temp_items, function(item) {
        $scope.tabs[1].items = _.reject($scope.tabs[1].items, function(i) {
          return i.id == item.id;
        });
      });
      $scope.set_tab_properties(1);
    };

    $scope.set_tab_properties = function(tab_index) {
      $scope.tabs[tab_index].has_reels = _.select($scope.tabs[tab_index].items, function(i) {
        return i.is_reels === true;
      }).length > 0;
      $scope.tabs[tab_index].has_sheets = _.select($scope.tabs[tab_index].items, function(i) {
        return i.is_reels === false;
      }).length > 0;
    };

    $scope.create_offer = function() {
      if (!window.offer && !$scope.filter.supplier_id && !window.personal_mode) {
        alert('Please select a supplier!');
      } else if (window.offer && !$scope.filter.buyer_id && window.personal_mode) {
        alert('Please select a buyer!');
      } else {
        var items = [];
        angular.forEach($scope.tabs[1].items, function(item) {
          items.push(item.id);
        });
        $scope.creating_offer = true;
        OfferService.create_offer_from_items(items, $scope.filter, $scope.offer_options).then(function(data) {
          if (data.data.success) {
            $scope.creating_offer = false;
            window.location = '/admin/marketplace/offers/edit_main_title/' + data.data.offer_id;
          }
        });
      }
    };

    $scope.offer_options = {
      is_connected: false,
      is_inventory: false
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.personal_mode = window.personal_mode;
      $scope.show_fca = true;
      $scope.show_fas = false;
      $scope.show_cfr = false;
      $scope.show_dap = false;
      $scope.set_supplier_autocomplete($('input.supplier_company'));
      if (window.personal_mode) {
        $scope.set_buyer_autocomplete($('input.buyer_company'));
      }
      $scope.buyer_user_products = [];
      $scope.offer = window.offer;
      $scope.set_filter();
    };

    $scope.init();
  }
}

OfferInventories.$inject = ['$scope', 'OfferService', 'UserService', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-inventories.ctrl.js